/**
 * Shared bundle tier progress bar — used by bundle builder and cart.
 */
window.BundleProgress = class BundleProgress {
  constructor(root, { tiers = [], count = 0 } = {}) {
    this.root = root;
    this.tiers = tiers;
    this.count = count;
    this.progressBar = root.querySelector("[data-progress-fill]");
    this.progressSteps = root.querySelectorAll("[data-progress-step]");
    this.activeTierDetail = root.querySelector("[data-active-tier-detail]");
  }

  setCount(count) {
    this.count = count;
    return this.render();
  }

  getActiveTier() {
    let active = null;
    for (const tier of this.tiers) {
      if (this.count >= Number(tier.qty)) active = tier;
    }
    return active;
  }

  getTierVisualPositions() {
    const n = this.tiers.length;
    if (n === 0) return [];
    return this.tiers.map((tier, index) => ({
      ...tier,
      visualPos: ((index + 1) / n) * 100,
    }));
  }

  getProgressPercent() {
    const count = this.count;
    const tiers = this.getTierVisualPositions();
    if (!tiers.length || count <= 0) return 0;

    const maxQty = Number(tiers[tiers.length - 1].qty);
    if (count >= maxQty) return 100;

    const first = tiers[0];
    const firstQty = Number(first.qty);
    if (count < firstQty) {
      if (firstQty <= 0) return 0;
      return (count / firstQty) * first.visualPos;
    }

    for (let i = 0; i < tiers.length - 1; i++) {
      const curr = tiers[i];
      const next = tiers[i + 1];
      const currQty = Number(curr.qty);
      const nextQty = Number(next.qty);

      if (count >= currQty && count <= nextQty) {
        if (count === nextQty) return next.visualPos;
        const qtySpan = nextQty - currQty;
        if (qtySpan <= 0) return curr.visualPos;
        const ratio = (count - currQty) / qtySpan;
        return curr.visualPos + ratio * (next.visualPos - curr.visualPos);
      }
    }

    return 100;
  }

  getDisplayTier() {
    const active = this.getActiveTier();
    if (active) return active;
    if (this.count > 0 && this.tiers.length) return this.tiers[0];
    return null;
  }

  render() {
    const percent = this.getProgressPercent();
    const activeTier = this.getActiveTier();
    const displayTier = this.getDisplayTier();

    if (this.progressBar) {
      this.progressBar.style.width = `${percent}%`;
    }

    this.progressSteps?.forEach((step) => {
      const qty = Number(step.dataset.qty || 0);
      const reached = this.count >= qty;
      const active = activeTier && Number(activeTier.qty) === qty;
      step.classList.toggle("is-reached", reached);
      step.classList.toggle("is-active", Boolean(active));
    });

    this.updateActiveTierDetail(displayTier, Boolean(activeTier));
  }

  updateActiveTierDetail(displayTier, isReached = true) {
    const slot = this.activeTierDetail;
    if (!slot) return;

    if (!displayTier) {
      slot.hidden = true;
      slot.innerHTML = "";
      slot.classList.remove("is-active");
      return;
    }

    const scope = this.root.closest("[data-bundle-progress-scope]");
    const template = scope?.querySelector(
      `template[data-tier-preview][data-qty="${displayTier.qty}"]`,
    );

    if (!template) {
      slot.hidden = true;
      slot.innerHTML = "";
      slot.classList.remove("is-active");
      return;
    }

    slot.innerHTML = template.innerHTML;
    slot.hidden = false;
    slot.classList.toggle("is-active", isReached);
  }
};

if (!customElements.get("cart-bundle-progress")) {
  customElements.define(
    "cart-bundle-progress",
    class CartBundleProgress extends HTMLElement {
      connectedCallback() {
        let tiers = [];
        try {
          tiers = JSON.parse(
            this.querySelector("[data-bundle-tiers]")?.textContent || "[]",
          );
        } catch (e) {
          tiers = [];
        }

        this.controller = new window.BundleProgress(
          this.querySelector(".bundle-progress__layout") || this,
          {
            tiers,
            count: Number(this.dataset.itemCount || 0),
          },
        );
        this.controller.render();
      }
    },
  );
}
